import MasterLayout from 'components/layouts/MasterLayout'
import { LoadingBarProcess } from 'components/loadingProcess/LoadingBarProcess'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

const LoginPage = React.lazy(() => import('pages/login/LoginPage'))

const LoginRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <React.Suspense fallback={<LoadingBarProcess />}>
          <LoginPage />
        </React.Suspense>
      }>
      </Route>
    </Routes>
  )
}

export default LoginRoutes